import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-change-pass-dialog',
  templateUrl: './change-pass-dialog.component.html',
  styleUrls: ['./change-pass-dialog.component.css']
})
export class ChangePassDialogComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<ChangePassDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any ) { }

  ngOnInit() {
  }

  onPassChanged( event )  {
    this.dialogRef.close(false);
  }

}
